module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-infinite"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Infinite Scroll")]), _vm._v(" "), _c('p', {
    staticClass: "page-infinite-desc"
  }, [_vm._v("当即将滚动至列表底部时, 自动加载更多数据")]), _vm._v(" "), _c('div', {
    ref: "wrapper",
    staticClass: "page-infinite-wrapper",
    style: ({
      height: _vm.wrapperHeight + 'px'
    })
  }, [_c('ul', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "page-infinite-list",
    attrs: {
      "infinite-scroll-disabled": "loading",
      "infinite-scroll-distance": "50"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('li', {
      staticClass: "page-infinite-listitem"
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "page-infinite-loading"
  }, [_c('mt-spinner', {
    attrs: {
      "type": "fading-circle"
    }
  }), _vm._v("\n      加载中...\n    ")], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-064ab0b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/infinite-scroll.vue
// module id = 263
// module chunks = 0